import React from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  Stack,
  useTheme,
  alpha,
} from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { MdDateRange, MdAddShoppingCart, MdChecklist } from "react-icons/md";

const EmployeeQuickActionsCard = ({ isFeatureEnabled = () => true }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isDark = theme.palette.mode === "dark";

  const actions = [
    {
      title: "Apply Leave",
      icon: MdDateRange,
      path: "/company/apply-leave",
      show: isFeatureEnabled("leave"),
    },
    {
      title: "Create Requisition",
      icon: MdAddShoppingCart,
      path: "/company/requisition-create",
      show: isFeatureEnabled("employees"),
    },
    {
      title: "Project Tasks",
      icon: MdChecklist,
      path: "/company/tasks",
      show: isFeatureEnabled("projects"),
    },
  ];

  const visibleActions = actions.filter((a) => a.show);
  if (visibleActions.length === 0) return null;

  return (
    <Paper
      component={motion.div}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.15 }}
      elevation={0}
      sx={{
        p: { xs: 2.5, sm: 3 },
        borderRadius: 1,
        background: isDark
          ? "linear-gradient(135deg, rgba(245, 158, 11, 0.14) 0%, rgba(217, 119, 6, 0.08) 100%)"
          : "linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)",
        border: "1px solid",
        borderColor: isDark ? alpha("#f59e0b", 0.35) : "#fed7aa",
        boxShadow: isDark
          ? "0 10px 30px rgba(0, 0, 0, 0.35)"
          : "0 10px 30px rgba(245, 158, 11, 0.08)",
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 800,
          fontSize: "0.78rem",
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          color: isDark ? "#fcd34d" : "#b45309",
          mb: 2,
        }}
      >
        Quick Actions
      </Typography>

      <Stack direction="column" spacing={1.5} sx={{ width: "100%" }}>
        {visibleActions.map((action) => {
          const Icon = action.icon;
          return (
            <Button
              key={action.title}
              onClick={() => navigate(action.path)}
              startIcon={<Icon size={18} />}
              fullWidth
              sx={{
                flex: 1,
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 700,
                fontSize: "0.9rem",
                py: 1.25,
                px: 2,
                background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                color: "#ffffff",
                boxShadow: "0 2px 6px rgba(245, 158, 11, 0.18)",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #d97706 0%, #b45309 100%)",
                  boxShadow: "0 3px 8px rgba(245, 158, 11, 0.25)",
                },
              }}
            >
              {action.title}
            </Button>
          );
        })}
      </Stack>
    </Paper>
  );
};

export default EmployeeQuickActionsCard;
